import { useSnackbar } from "notistack";
import { useMutation, useQuery } from "react-query";
import { useNavigate } from "react-router-dom";

import {
  Area,
  AreaInput,
  BaseQueryProps,
  BaseSearchQueryProps,
  ListResponseData,
} from "../types";
import {
  handleDelete,
  handleDetail,
  handleList,
  handleMutationError,
  handleQueryError,
  handleSave,
  handleSearch,
} from "./handler";

const methods = {
  useSearch: ({ query }: BaseSearchQueryProps) => {
    const navigate = useNavigate();
    return useQuery<Area[]>({
      queryKey: ["areas", query],
      queryFn: () => handleSearch({ baseUrl: "areas", query }),
      onError: handleQueryError(navigate),
    });
  },
  useSave: (areaInput: AreaInput) => {
    const navigate = useNavigate();
    return useMutation<Area>({
      mutationFn: () => handleSave({ baseUrl: "areas", input: areaInput }),
      onError: handleQueryError(navigate),
      retry: 1,
    });
  },
  useList: ({ order, orderBy, page, query }: BaseQueryProps<Area>) => {
    const navigate = useNavigate();
    return useQuery<ListResponseData<Area>>({
      cacheTime: 0,
      queryKey: ["areas", order, orderBy, page, query],
      queryFn: () =>
        handleList({ baseUrl: "areas", order, orderBy, page, query }),
      onError: handleQueryError(navigate),
    });
  },
  useDetail: (id: string | undefined) => {
    const navigate = useNavigate();
    return useQuery<Area>({
      cacheTime: 0,
      queryKey: ["area", id],
      queryFn: () => handleDetail({ baseUrl: "areas", id }),
      onError: handleQueryError(navigate),
    });
  },
  useDelete: (id?: number) => {
    const { enqueueSnackbar } = useSnackbar();
    return useMutation<Area>({
      mutationFn: () => handleDelete({ baseUrl: "areas", id }),
      retry: 1,
      onError: handleMutationError(enqueueSnackbar),
    });
  },
};

export default methods;
